<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="loadData(1)">刷新</el-button>
            </div>
            <div class="header-right">
                <!-- <el-select v-model="filterParams.customer_id" placeholder="请选择出品人" @change="loadData(1)"
                    class="header-input">
                    <el-option :label="'不限出品人'" :value="''"></el-option>
                    <el-option v-for="item in customers" :key="item.customerId" :label="item.customerName"
                        :value="item.customerId"></el-option>
                </el-select> -->
                <!-- <el-select v-model="filterParams.product_status" placeholder="请选择钱币状态" @change="loadData(1)"
                    class="header-input">
                    <el-option :label="'不限钱币状态'" :value="''"></el-option>
                    <el-option v-for="item in productStatusArray" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select> -->
                <el-select v-model="filterParams.grade_id" placeholder="请选择评级公司" @change="loadData(1)"
                    class="header-input">
                    <el-option :label="'不限评级公司'" :value="''"></el-option>
                    <el-option v-for="item in grades" :key="item.gradeId" :label="item.gradeName"
                        :value="item.gradeId"></el-option>
                </el-select>
                <el-select v-model="filterParams.category_id" placeholder="请选择钱币朝代" @change="loadData(1)" class="header-input">
                    <el-option :label="'不限钱币朝代'" :value="''"></el-option>
                    <el-option :label="group.categoryName" :value="group.categoryId" v-for="group in categorys"></el-option>
                </el-select>
                <el-select v-model="filterParams.category_child_id" placeholder="子分类" @change="loadData(1)"
                    style="width: 105px;" class="header-input" v-if="!category || all">
                    <el-option :label="'不限子分类'" :value="''"></el-option>
                    <el-option :label="group.categoryChildName" :value="group.categoryChildId"
                        v-for="group in getCategoryChilds(filterParams.category_id)"></el-option>
                </el-select>
                <el-select v-model="filterParams.address_id" placeholder="请选择库存地" @change="loadData(1)" class="header-input">
                    <el-option :label="'不限库存地'" :value="''"></el-option>
                    <el-option :label="address.addressName" :value="address.addressId" v-for="address in addresses"></el-option>
                </el-select>
                <el-input v-model="filterParams.product_appraisal" placeholder="请输入评级编码" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-input v-model="filterParams.product_prize_start" placeholder="请输入价格下限" class="header-input"
                    @change="loadData(1)" v-if="!minPrize"></el-input>
                <el-input v-model="filterParams.product_prize_end" placeholder="请输入价格上限" class="header-input"
                    @change="loadData(1)" v-if="!maxPrize"></el-input>
                <el-input v-model="filterParams.product_name" placeholder="请输入钱币名称" class="header-input"
                    @change="loadData(1)"></el-input>
                <!-- <el-select v-model="filterParams.type" @change="loadData(1)" class="header-input" style="width: 170px;">
                    <el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select> -->
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <div style="display: flex; flex-wrap: wrap; gap: 0px;">
            <product-component v-for="product in records" :product="product" @dropDownClick="dropDownClick"></product-component>
        </div>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40, 100, 500]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getLogTypeName(scheduleForm.logType)" :visible.sync="statusLayer" width="30%"
            :close-on-click-modal="false">
            <el-form ref="form" label-width="90px">
                <el-form-item label="代卖人" v-if="(manager || distribute) && scheduleForm.logType > 1">
                    <el-select v-model="scheduleForm.salerId" placeholder="请选择代卖人" style="width: 100%;">
                        <el-option v-for="item in saleAdmins" :key="item.adminId" :label="item.adminName"
                            :value="item.adminId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="评级编码" v-if="(manager || distribute) && scheduleForm.logType == 1">
                    <el-input v-model="scheduleForm.productCode"></el-input>
                </el-form-item>
                <el-form-item label="操作备注">
                    <el-input v-model="scheduleForm.memo"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateStatusClose()">取 消</el-button>
                <el-button type="primary" @click="updateStatusConfirm()">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="操作日志" :visible.sync="logLayer" width="30%" :close-on-click-modal="false">
            <div class="block">
                <el-timeline>
                    <el-timeline-item v-for="(log, index) in logs" :key="index" type="primary" color="#0bbd87"
                        size="large" :timestamp="convertToDate(log.logDate)">
                        {{ getLogTypeName(log.logType) }}
                        <span v-if="log.salerId"> / 代卖人：{{ log.salerName }}</span>
                        <span v-if="log.adminId"> / 操作人：{{ log.adminName }}</span>
                        <span v-if="log.logMemo" style="color: #FF0000; font-weight: bold;"> / 备注：{{ log.logMemo
                            }}</span>
                    </el-timeline-item>
                </el-timeline>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="logLayer = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import uploadMixin from "@/mixins/upload-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"
import enumMixin from "@/mixins/enum-mixin.js"
import scheduleMixin from "@/mixins/schedule-mixin.js"
import productComponent from "@/components/ProductComponent.vue"

import { API, doGet, doPost } from "@/api/api.js"

export default {
    props: {
        type: {
            type: Number,
            default: 0
        },
        minPrize: {
            type: String,
            default: ""
        },
        maxPrize: {
            type: String,
            default: ""
        },
    },
    mixins: [verifyMixin, listMixin, uploadMixin, imageMixin, enumMixin, scheduleMixin],
    data: function () {
        return {
            categorys: [],
            categorychilds: [],
            application: true,
            adminSuper: 0,
            popovers: [],
            productId: "",
            productStatus: 0,
            statusLayer: false,
            statusAdminId: "",
            customers: [],
            grades: [],
            addresses: [],
            admins: [],
            types: [
                {
                    label: "所有数据",
                    value: 0
                },
                {
                    label: "7天上新",
                    value: 1
                },
                {
                    label: "价格调整（7天内）",
                    value: 2
                }
            ]
        }
    },
    methods: {
        getCategoryChilds: function(categoryId) {
            let categoryChilds = [];
            for (let i = 0; i < this.categorychilds.length; i++) {
                if (this.categorychilds[i].categoryId == categoryId) {
                    categoryChilds.push(this.categorychilds[i]);
                }
            }
            return categoryChilds;
        },
        dropDownClick: function(productId, type, productAppraisal) {
            this.updateStatusOpen(productId, type, productAppraisal);
        },
        reloadData: async function () {
            await doGet(API.CATEGORY_READ, { type: this.type });
            this.customers = await doGet(API.ALL.CUSTOMER);
            this.grades = await doGet(API.ALL.GRADE);
            this.admins = await doGet(API.ALL.ADMIN);
            this.categorys = await doGet(API.TREE.CATEGORY);
            this.categorychilds = await doGet(API.ALL.CATEGORY_CHILD);
            this.addresses = await doGet(API.ALL.ADDRESS);
            this.$forceUpdate();
        },
    },
    created: function () {
        doGet(API.ADMIN_SUPER).then(res => {
            this.adminSuper = res;
        });
        this.size = 20;
        this.tag = "PRODUCT";
        this.uploads.push({
            column: "productImages",
            files: []
        });
        this.filterParams = {
            product_public: "1",
            customer_id: "",
            product_status: "",
            grade_id: "",
            category_id: "",
            address_id: "",
            product_appraisal: "",
            product_prize_start: "",
            product_prize_end: "",
            product_name: "",
            type: this.type,
        };
        if (this.minPrize) {
            this.filterParams.product_prize_start = this.minPrize;
        }
        if (this.maxPrize) {
            this.filterParams.product_prize_end = this.maxPrize;
        }
    },
    components: {
        "product-component": productComponent
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
@import "@/assets/style/upload-style.less";
</style>